import { useEffect, useState } from 'react'

export type DeviceType = 'ios' | 'android' | 'other'

export function useDeviceInfo(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>('other')

  useEffect(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return
    }

    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      setDeviceType('ios')
    } else if (/android/i.test(userAgent)) {
      setDeviceType('android')
    } else {
      setDeviceType('other')
    }
  }, [])

  return deviceType
}
